<!-- Global Hero Header -->
<header class="hero-section-global">
  <div class="hero-background-global"
    style="background-image: url('https://images.ctfassets.net/f6ou4743hwzs/2xaL3IYyS5iU8bcXoWAOdX/9d1784950839614bbbcaa593c23ee090/whyblm.jpg'); background-position: center 40%;">
  </div>
  <div class="hero-overlay-global"></div>
  <div class="hero-content-global">
    <span class="hero-badge">Museum Heritage Store</span>
    <h1 class="hero-title-global">Bayou Books & Gifts</h1>
    <p class="hero-subtitle">
      100% of proceeds directly fund historic preservation, artifact acquisition, and educational programs.
    </p>
  </div>
</header>

<main class="shop-container">
  <!-- Member Discount Banner -->
  <aside class="member-perk-banner">
    <mat-icon>card_membership</mat-icon>
    <div class="perk-text">
      <strong>Museum Members Save 20%</strong>
      <span>All active members enjoy a 20% discount on all gift shop items and books. <a routerLink="/memberships">Join today &rarr;</a></span>
    </div>
  </aside>

  <!-- Category Filter Pills -->
  <nav class="category-filters" aria-label="Product Categories">
    <button 
      type="button" 
      class="filter-pill" 
      [class.active]="selectedCategory === 'all'"
      (click)="selectedCategory = 'all'">
      All Items
    </button>
    <button 
      type="button" 
      class="filter-pill" 
      [class.active]="selectedCategory === 'books'"
      (click)="selectedCategory = 'books'">
      Books & History
    </button>
    <button 
      type="button" 
      class="filter-pill" 
      [class.active]="selectedCategory === 'crafts'"
      (click)="selectedCategory = 'crafts'">
      Souvenirs & Crafts
    </button>
    <button 
      type="button" 
      class="filter-pill" 
      [class.active]="selectedCategory === 'apparel'"
      (click)="selectedCategory = 'apparel'">
      Apparel
    </button>
    <button 
      type="button" 
      class="filter-pill" 
      [class.active]="selectedCategory === 'prints'"
      (click)="selectedCategory = 'prints'">
      Art Prints
    </button>
  </nav>

  <!-- Items Grid -->
  <div class="products-grid">
    <article *ngFor="let item of filteredItems" class="product-card">
      <div class="product-image-wrap">
        <img [src]="item.imageUrl" [alt]="item.name" loading="lazy">
        <span class="category-badge">{{ item.categoryLabel }}</span>
        <span class="featured-badge" *ngIf="item.featured">Featured</span>
      </div>

      <div class="product-info">
        <div class="price-row">
          <span class="product-price">${{ item.price }}</span>
          <span class="stock-indicator">In Stock</span>
        </div>

        <h2 class="product-name">{{ item.name }}</h2>
        <p class="product-desc">{{ item.description }}</p>

        <button 
          type="button" 
          class="buy-inquiry-btn"
          (click)="openOrderModal(item)">
          <mat-icon>shopping_bag</mat-icon>
          <span>Purchase / Reserve Item</span>
        </button>
      </div>
    </article>
  </div>

  <!-- On-site Visit Callout -->
  <section class="visit-store-callout">
    <mat-icon>storefront</mat-icon>
    <div>
      <h3>Visit the Museum Store in Person</h3>
      <p>The on-site museum store inside the 1912 schoolhouse features local honey, regional folklore publications, handcrafted woodwork, and indigenous basketwork reproductions. Open Saturdays Noon–4 PM.</p>
    </div>
  </section>

  <!-- Order / Inquiry Modal Overlay -->
  <div class="modal-backdrop" *ngIf="selectedItem" (click)="closeOrderModal()">
    <div class="modal-card" (click)="$event.stopPropagation()">
      <button type="button" class="modal-close-btn" (click)="closeOrderModal()" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>

      <div [hidden]="orderSubmitted">
        <span class="modal-category">{{ selectedItem.categoryLabel }}</span>
        <h3 class="modal-title">{{ selectedItem.name }}</h3>
        <p class="modal-price">${{ selectedItem.price }} each</p>

        <div class="quantity-row">
          <label>Quantity:</label>
          <input type="number" min="1" max="10" [(ngModel)]="buyerQuantity" class="qty-input">
          <span class="total-calc">Total: <strong>${{ selectedItem.price * buyerQuantity }}</strong></span>
        </div>

        <div class="modal-form-fields">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Your Name</mat-label>
            <input matInput [(ngModel)]="buyerName" placeholder="Full name">
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Email Address</mat-label>
            <input matInput type="email" [(ngModel)]="buyerEmail" placeholder="your-email@example.com">
          </mat-form-field>
        </div>

        <button 
          type="button" 
          class="confirm-order-btn"
          (click)="submitOrderInquiry()">
          <mat-icon>receipt_long</mat-icon>
          <span>Continue to Order Options</span>
        </button>
      </div>

      <!-- Order Inquiry Success View -->
      <div class="order-success-view" *ngIf="orderSubmitted">
        <mat-icon class="success-icon">check_circle</mat-icon>
        <h3>Order Ready to Submit</h3>
        <p>You have selected <strong>{{ buyerQuantity }}x {{ selectedItem.name }}</strong> (${{ selectedItem.price * buyerQuantity }}).</p>

        <div class="email-action-box">
          <p class="email-action-desc">
            Click below to open your email client with your prefilled order details to arrange pickup or delivery:
          </p>
          <a [href]="orderMailtoLink" class="email-confirm-btn">
            <mat-icon>email</mat-icon>
            <span>Send Order via Email</span>
          </a>
        </div>

        <button mat-stroked-button color="primary" (click)="closeOrderModal()" style="margin-top: 1rem;">
          Back to Store
        </button>
      </div>
    </div>
  </div>
</main>
